import { Box, Link, Typography } from '@mui/material';

export const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        py: 1,
        px: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        zIndex: 1000,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Contact us:
      </Typography>
      <Link
        href="mailto:info@workbench-studio.com"
        underline="hover"
        color="text.secondary"
        aria-label="Email us at info@workbench-studio.com"
      >
        <Typography variant="body2">info@workbench-studio.com</Typography>
      </Link>
      <Typography variant="body2" color="text.secondary">
        |
      </Typography>
      <Link
        href="tel:+1-719-208-4004"
        underline="hover"
        color="text.secondary"
        aria-label="Call us at 719-208-4004"
      >
        <Typography variant="body2">(719) 208-4004</Typography>
      </Link>
    </Box>
  );
};
